export enum EngagementState {
    ENGAGED = "ENGAGED", DISENGAGED = "DISENGAGED", "ENGAGING" = "ENGAGING", "DISENGAGING" = "DISENGAGING"
}
